/**
 * Normalize raw text from camera, USB/Bluetooth HID scanners, or paste.
 */
export function normalizeScanPayload(raw) {
  return String(raw || '')
    .replace(/\u200b/g, '')
    .replace(/^\uFEFF/, '')
    .replace(/\r/g, '')
    .trim();
}

/**
 * Resolve Omnichek QR id for internal (field) scans from a URL or plain payload.
 * Supports verify links, GS1 Digital Link path /01/{gtin}/21/{serial}, and raw ids (e.g. MASTER-…, UUID).
 */
export function extractInternalScanQrId(raw) {
  const t = normalizeScanPayload(raw);
  if (!t) return null;

  const verifyPath = t.match(/\/verify\/([^/?#]+)/i);
  if (verifyPath?.[1]) return decodeURIComponent(verifyPath[1]).trim();

  const gs1Serial = t.match(/\/01\/[^/?#]+\/21\/([^/?#]+)/i);
  if (gs1Serial?.[1]) return decodeURIComponent(gs1Serial[1]).trim();

  try {
    let u;
    if (/^https?:\/\//i.test(t)) u = new URL(t);
    else if (t.includes('://')) u = new URL(t);
    else u = new URL(`https://${t}`);
    const parts = u.pathname.split('/').filter(Boolean);
    const vIdx = parts.findIndex((p) => /^verify$/i.test(p));
    if (vIdx >= 0 && parts[vIdx + 1]) return decodeURIComponent(parts[vIdx + 1]).trim();
    const gs1 = u.pathname.match(/\/01\/[^/]+\/21\/([^/]+)/i);
    if (gs1?.[1]) return decodeURIComponent(gs1[1]).trim();
  } catch {
    /* not a URL */
  }

  if (/^[A-Za-z0-9._-]+$/.test(t) && t.length > 0 && t.length < 256) return t;

  return null;
}
